import { render, staticRenderFns } from "./NotifyRecord.vue?vue&type=template&id=49f66b63&"
import script from "./NotifyRecord.vue?vue&type=script&lang=js&"
export * from "./NotifyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/研訊/shopstore_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f66b63')) {
      api.createRecord('49f66b63', component.options)
    } else {
      api.reload('49f66b63', component.options)
    }
    module.hot.accept("./NotifyRecord.vue?vue&type=template&id=49f66b63&", function () {
      api.rerender('49f66b63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/NotifyRecord.vue"
export default component.exports